<template>
	<v-dialog
		v-model="dialog"
		max-width="1000"
		@click:outside="$emit('close')"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
		:scrollable="false"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">却下の理由</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="$emit('close')" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet elevation="0" class="pa-4">
				<v-form v-model="isValid">
					<v-textarea
						v-model="setReason"
						:rules="[rules.required]"
						class="mt-4"
						label="却下の理由(必須)"
						outlined
						dense
					></v-textarea>
					<v-row class="ma-0 pa-0" justify="center">
						<v-btn
							@click="$emit('reject')"
							class="ma-1 white--text font-weight-bold"
							:disabled="!isValid"
							dense
							color="red"
							>却下する</v-btn
						>
					</v-row>
				</v-form>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import rules from "../../../helper/rules"

export default {
	props: {
		reason: {
			type: String,
			required: false,
		},
	},
	data() {
		return {
			rules,
			dialog: true,
			isValid: false,
		}
	},
	computed: {
		setReason: {
			get() {
				return this.reason
			},
			set(newValue) {
				return this.$emit("update:reason", newValue)
			},
		},
	},
}
</script>
